import React from "react";
import { AiFillCaretDown } from "react-icons/ai";
import { Link } from "react-router-dom";
import item1 from "../../assets/svgs/item1.svg";
import item2 from "../../assets/svgs/item2.svg";
import item3 from "../../assets/svgs/item3.svg";
import item4 from "../../assets/svgs/item4.svg";
import SSCItem from "./SSCItem";

const SSC = () => {
  const rowOneData = [
    {
      svg: item1,
      title: "IT Services",
      desc: "We offers IT solutions for businesses, including hardware/software installation, cloud-based networking, and data storage to improve efficiency and save time and money.",
    },
    {
      svg: item2,
      title: "Cloud & Server",
      desc: "RemotewebNET provides secure and scalable cloud and server solutions, utilizing cutting-edge technologies like virtualization and automation, to support customers' growing businesses while ensuring the safety of their data with the latest security standards and protocols.",
    },
  ];
  const rowTwoData = [
    {
      svg: item3,
      title: "Software Solutions",
      desc: "We provides customized software solutions utilizing advanced technologies like AI and machine learning to enhance productivity, efficiency and user experience while maintaining utmost security.",
    },
    {
      svg: item4,
      title: "Networking & Switching",
      desc: "We offers high-performance, secure, and scalable network solutions, built on cutting-edge technologies and rigorous safety measures to prevent potential threats and provide customers with a reliable and efficient experience.",
    },
  ];
  const container =
    "md:flex block items-center justify-center md:space-x-6 md:py-5";
  return (
    <div className="bg-gray-50 w-full py-20">
      <center className="mb-6">
        <h1 className="font-light text-4xl text-black uppercase">service</h1>
        <h1 className="font-light text-4xl text-black uppercase">
          <span className="text-pink-600">solution</span> cloud
        </h1>
        <AiFillCaretDown className="text-pink-600" />
      </center>
      <div className={container}>
        {rowOneData.map((item, index) => (
          <SSCItem
            key={index}
            title={item.title}
            svgUrl={item.svg}
            desc={item.desc}
          />
        ))}
      </div>
      <div className={container}>
        {rowTwoData.map((item, index) => (
          <SSCItem
            key={index}
            title={item.title}
            svgUrl={item.svg}
            desc={item.desc}
          />
        ))}
      </div>
      <div className="flex justify-center mt-5">
        <Link
          style={{ color: "#293586", border: "solid 1px #293586" }}
          className="py-2 px-10 font-medium rounded-sm shadow-sm"
          to={"/it-services"}
        >
          Other Services
        </Link>
      </div>
    </div>
  );
};

export default SSC;
